/*
 * @Author: your name
 * @Date: 2021-02-07 14:41:16
 * @LastEditTime: 2021-03-24 15:35:53
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \ylb_web_v1.0.0\src\router\ht.js
 */
/**
 * Created by hls on 2017/11/22
 * bd基础模块路由.
 */

import _import from './_import_development'

export  default {
  path: '/ht',
  name: 'ht',
  component: _import("Home"),
  meta: {permission: false},
  children: [
    { path: 'ContractList',component:_import("ht/ContractList"),name:'合同列表',meta:{ keepAlive:true }},
    { path: 'ContractInfo',component:_import("ht/ContractInfo"),name:'合同详情'},
    { path: 'ContractAdd',component:_import("ht/ContractAdd"),name:'合同编辑'},
    { path: 'ContractChangeList',component:_import("ht/ContractChangeList"),name:'合同变更列表'},
    { path: 'ContractChangeInfo',component:_import("ht/ContractChangeInfo"),name:'合同变更列表'},
    { path: 'ContractChangeAdd',component:_import("ht/ContractChangeAdd"),name:'合同变更编辑'},
    { path: 'ContractCustomerList',component:_import("ht/ContractCustomerList"),name:'合同列表'},
    { path: 'ContractCustomerInfo',component:_import("ht/ContractCustomerInfo"),name:'合同详情'},
    { path: 'ContractCustomerChangeInfo',component:_import("ht/ContractCustomerChangeInfo"),name:'合同变更详情'},
    { path: 'ContractPriceTable',component:_import("ht/ContractPriceTable"),name:'合同价表'},
    { path: 'DynamicLines',component:_import("ht/DynamicLines"),name:'客户动态信用额度表'},
    { path: 'ContractBatchUpdate',component:_import("ht/ContractBatchUpdate"),name:'批量修改'},
    { path: 'ContractBatchAdd',component:_import("ht/ContractBatchAdd"),name:'批量新增'},
    { path: 'ContractBatchAdjustment',component:_import("ht/ContractBatchAdjustment"),name:'批量调整'},

    // 公告
    { path: 'ContractNewsInfo',component:_import("ht/ContractNewsInfo"),name:'合同公告详情'},
    { path: 'ContractNewsAdd',component:_import("ht/ContractNewsAdd"),name:'合同公告修改'},
  
    // 返利
    { path: 'ConContractRebateRateList',component:_import("ht/ConContractRebateRateList"),name:'返利列表展示'},
    { path: 'ConContractRebateRateAdd',component:_import("ht/ConContractRebateRateAdd"),name:'返利添加'},
    { path: 'ConContractRebateRateinfo',component:_import("ht/ConContractRebateRateinfo"),name:'返利详情'},
    { path: 'ConContractRebateRateUpdate',component:_import("ht/ConContractRebateRateUpdate"),name:'返利更新'},
  
    // 返利明细表
    { path: 'ConContractRebateList',component:_import("ht/ConContractRebateList"),name:'返利列表'},
    { path: 'ConContractRebateInfo',component:_import("ht/ConContractRebateInfo"),name:'返利列表详情'},

    // 合同模板
    { path: 'CttempletList',component:_import("ht/CttempletList"),name:'合同列表'},
    { path: 'CttempletAdd',component:_import("ht/CttempletAdd"),name:'合同添加'},
    { path: 'CttempletInfo',component:_import("ht/CttempletInfo"),name:'合同详情'},

    // 超期合同
    { path: 'ExpireContractList',component:_import("ht/ExpireContractList"),name:'超期合同列表',meta:{ keepAlive:true }},
  ]
}



// WEBPACK FOOTER //
// ./src/router/ht.js